import { useTheme } from '@emotion/react';
import { MicrositeBreakpoint } from '~/model';
import { useEffect, useState } from 'react';

export default function useBreakpoint(): MicrositeBreakpoint | null {
	const theme = useTheme();
	const [breakpoint, setBreakpoint] = useState<MicrositeBreakpoint>();

	useEffect(() => {
		const handleResize = () => {
			const width = window.innerWidth;

			if (width >= theme.viewport.large) {
				setBreakpoint(MicrositeBreakpoint.LARGE);
			} else if (width >= theme.viewport.medium) {
				setBreakpoint(MicrositeBreakpoint.MEDIUM);
			} else {
				setBreakpoint(MicrositeBreakpoint.SMALL);
			}
		};

		handleResize();

		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return breakpoint ?? null;
}
